export default {
  getDateString(date = new Date(), dateType) {
    if(date) {
      switch (dateType) {
        case 'yyyy-MM-dd':
          return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        case 'yyyy-MM':
          return date.getFullYear() + '-' + (date.getMonth() + 1);
        case 'yyyyMMdd':

          break;
        case 'yy-MM-dd':

          break;
        case 'yyMMdd':

          break;
        case '年月日':
          return date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日';
        case '年月':
          return date.getFullYear() + '年' + (date.getMonth() + 1) + '月';
        case '年':
          return date.getFullYear() + '年';
      }
    }else {
      return date;
    }
  },

  getTomorrow(date = new Date()) {
    return new Date(date.getTime() + 86400000);
  },

  getYesterday(date = new Date()) {
    return new Date(date.getTime() - 86400000);
  },
  getLastweek(date = new Date()) {
    return new Date(date.getTime() - 518400000);
  },
  getLastMonth(date = new Date()) {
    let year = date.getFullYear();
    let month = date.getMonth();
    if (month === 0) {
      year = year - 1;
      month = 12;
    } else {
      month--;
    }
    return new Date(year, month);
  },

  getLastMonthDay1(date = new Date()) {
    let year = date.getFullYear();
    let month = date.getMonth();
    if (month === 0) {
      year = year - 1;
      month = 12;
    } else if (month < 10) {
      month = '0' + month;
    }
    return year + '-' + month + '-01';
  },

  getMonthFirstDay(date = new Date()) {
    let year = date.getFullYear();
    let month = date.getMonth();
    return new Date(new Date(year, month, 1));
  },

  getMonthLastDay(date = new Date()) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    return new Date(new Date(year, month, 1) - 86400000);
  },

  getDecade(date = new Date()) {
    return new Date(date.getTime() + (365 * 40 + 10) * 86400000);
  },

  getThreeYear(date = new Date(), isLater = true) {
    if(isLater) return new Date(date.getTime() + (365 * 3 + 10) * 86400000);
    else return new Date(date.getTime() - (365 * 3 + 10) * 86400000);
  },

  getTwentyYear(date = new Date(), isLater = true) {
    if(isLater) return new Date(date.getTime() + (365 * 20 + 10) * 86400000);
    else return new Date(date.getTime() - (365 * 20 + 10) * 86400000);
  },

  dateFormat(fmt, date) {
    let ret;
    let opt = {
      "Y+": date.getFullYear().toString(), // 年
      "m+": (date.getMonth() + 1).toString(), // 月
      "d+": date.getDate().toString(), // 日
      "H+": date.getHours().toString(), // 时
      "M+": date.getMinutes().toString(), // 分
      "S+": date.getSeconds().toString() // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      }
    }
    return fmt;
  },
  intToDateString(dateInt) {
    let year = parseInt(dateInt / 10000);
    let month = parseInt(dateInt / 100) - parseInt(dateInt / 10000) * 100;
    if (month < 10) { month = '0' + month; }
    let day = parseInt(dateInt % 100);
    if (day < 10) { day = '0' + day }
    return year + '-' + month + '-' + day;
  }
}



// WEBPACK FOOTER //
// ./src/utils/DateUtils.js